import { useMemo } from 'react';
import { map, assocPath } from 'ramda';

import content from 'locale/content/de/about.json';

export const useContent = () =>
  useMemo(
    () =>
      assocPath(
        ['partner', 'items'],
        map((item) => {
          const img = require(`assets/images/${item.image}`); // eslint-disable-line import/no-dynamic-require

          return { ...item, image: img?.default || img };
        }, content.partner.items),
        content
      ),
    []
  );
